export const defineConstant =
{
  'SESSION_EID': 'sessIden',
  'SESSION_TYPE': 'sessionType',
  'SESSION_USER': 'user',
  'SESSION_COLLEGE': 'collegeAdmin',
  'SESSION_ADMIN': 'admin',
  'SESSION_USER_ID': 'userId',
  'SESSION_COLLEGE_ID': 'collegeId',
  'SESSION_ADMIN_ID': 'adminUserId',
  'SESSION_REFFER': 'referrer_url',
  'SESSION_NAME': 'name',
  'STUDENT_PROFILE_IMAGE': 'https://collegerecon.com/assets/student-media/'
}